import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { StyledStack } from './styles';
import { VpBackButton } from '../../components';

export const VpAppBar = ({
  showBackButton = false,
  backLinkOverride = '',
  centerContent = null,
  leftContent = null,
  rightContent = null,
  borderTop = false,
  onBack
}) => {
  return (
    <StyledStack borderTop={borderTop} direction="row" justifyContent="space-between">
      <Stack direction="row" spacing="15px" alignItems="center">
        {(showBackButton || !!backLinkOverride) && (
          <VpBackButton backLinkOverride={backLinkOverride} onBack={onBack} />
        )}
        {leftContent && leftContent}
      </Stack>
      <Stack direction="row" spacing="15px" alignItems="center">
        {centerContent && centerContent}
      </Stack>
      <Stack direction="row" spacing="15px">
        {rightContent && rightContent}
      </Stack>
    </StyledStack>
  );
};

VpAppBar.propTypes = {
  showBackButton: PropTypes.bool,
  backLinkOverride: PropTypes.string,
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
  centerContent: PropTypes.node,
  borderTop: PropTypes.bool,
  onBack: PropTypes.func
};

export default VpAppBar;



// WEBPACK FOOTER //
// ./src/vp-ui/layout/VpAppBar/VpAppBar.jsx